import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_novabuild-supply/artifacts/9b9k5pgs_ChatGPT%20Image%20Jan%2019%2C%202026%2C%2008_00_23%20AM.png" 
              alt="Nova Global Supply" 
              className="h-12 w-auto brightness-0 invert"
            />
            <p className="text-sm">
              Premium construction supplies for Canadian builders, engineers, and inspectors.
            </p>
          </div>

          {/* Products */}
          <div>
            <h3 className="font-semibold text-white mb-4">Products</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/products/versaduct" className="hover:text-green-400 transition-colors">
                  VersaDuct
                </Link>
              </li>
              <li>
                <Link to="/products/nova-faucets" className="hover:text-green-400 transition-colors">
                  Nova Faucets
                </Link>
              </li>
              <li>
                <Link to="/products/versaflex-csst" className="hover:text-green-400 transition-colors">
                  VersaFlex CSST
                </Link>
              </li>
              <li>
                <Link to="/products/nova-floors" className="hover:text-green-400 transition-colors">
                  Nova Floors
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-green-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-green-400 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-white mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0 text-green-400" />
                <span>Canada</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-4 w-4 flex-shrink-0 text-green-400" />
                <span>Available upon request</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="h-4 w-4 flex-shrink-0 text-green-400" />
                <Link to="/contact" className="hover:text-green-400 transition-colors">
                  Contact Form
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-sm text-center">
          <p>&copy; {new Date().getFullYear()} Nova Global Supply. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;